import { login, loginByCode } from '@api/auth';
import { SET_TOKEN } from '@constants/store';
import { LOGINED, LOGIN_STATUS, ACCESS_TOKEN } from '@constants/common';
import { toLogin } from '@helpers/unauthorization';
import Cookies from 'js-cookie';

export default {
    state: {
        token: Cookies.get(ACCESS_TOKEN) || ''
    },
    mutations: {
        [SET_TOKEN]: (state, token) => {
            if (token) {
                Cookies.set(LOGIN_STATUS, LOGINED, {
                    expires: new Date(Date.now() + 6 * 60 * 60 * 1000)
                });
                Cookies.set(ACCESS_TOKEN, token, {
                    expires: new Date(Date.now() + 6 * 60 * 60 * 1000)
                });
            }
            state.token = token;
        }
    },
    actions: {
        async login({ commit }, { cellphone, password }) {
            const { code, access_token, msg } = await login(cellphone, password);
            if (code === 0) {
                commit(SET_TOKEN, access_token);
            } else {
                return Promise.reject(new Error(msg));
            }
        },
        async loginByCode({ commit }, { cellphone, validationCode }) {
            const { code, access_token, msg } = await loginByCode(cellphone, validationCode);
            if (code === 0) {
                commit(SET_TOKEN, access_token);
            } else {
                return Promise.reject(new Error(msg));
            }
        },
        async logout({ commit }, backLogin = false) {
            Cookies.remove(ACCESS_TOKEN);
            Cookies.remove(LOGIN_STATUS);
            commit(SET_TOKEN, null);
            commit('SET_USERINFO', {}, { root: true });
            if (backLogin) {
                toLogin();
            }
        }
    }
};
